import React, {useCallback, useEffect, useState} from 'react';
import '../../css/mobile/MAdminUserInfo.css';
import '../../css/mobile/MAdmin.css';
import axios from '../../services/axiosInstance';
import {MdKeyboardArrowDown} from "react-icons/md";
import MsgSelectModal from "../../components/web/modal/MsgSelectModal";
import TopBtn from "../../components/web/layoutsadmin/TopBtn";
import maCateImg from "../../assets/img/m-a-cate.png";
import MAdminPageSmallEvent from "./MAdminPageSmallEvent";
import MAdminSearchEvent from "./MAdminSearchEvent";
import deposit from "../../assets/img/depositPay.png";
import pointPay from "../../assets/img/pointPay.png";
import mail from "../../assets/img/mailFl.png";
import outFl from "../../assets/img/outFl.png";
import profileImage from "../../assets/img/profileDefaultImg.png";
import coupons from "../../assets/img/coupons.png";

function MAdminUserInfoPg() {

    /**region DataTable */

    const [userData, setUserData] = useState([]);
    const [expandedRow, setExpandedRow] = useState(null); // 현재 펼쳐진 행의 index

    /** endregion */

    /** region Function */

    const LCAT = localStorage.getItem('adminToken');

    //region Search

    const [searchInput, setSearchInput] = useState('');
    const handleSearchInputChange = (event) => {
        setSearchInput(event.target.value);
    };

    const searchData = userData.filter((cData) => {
        return cData.userName.toLowerCase().includes(searchInput.toLowerCase());
    });

    //endregion

    //region ScrollPagination

    const [displayLimit, setDisplayLimit] = useState(10);

    useEffect(() => {
        select();
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [searchData.length, displayLimit]);

    const handleScroll = () => {
        if (window.innerHeight + document.documentElement.scrollTop !== document.documentElement.offsetHeight) return;
        if (searchData.length > displayLimit && displayLimit < 30) {
            setDisplayLimit(prevLimit => prevLimit + perPg);
        }
    };

    const loadMoreData = () => {
        setDisplayLimit(prevLimit => prevLimit + perPg);
    };

    // endregion

    // region Pagination

    const [currentPage, setCurrentPage] = useState(1);
    const [perPg, setperPg] = useState(10);
    const indexOfLast = currentPage * perPg;
    const indexOfFirst = indexOfLast - perPg;
    const handleSelectChange = (e) => {
        setperPg(parseInt(e));
        setDisplayLimit(parseInt(e));
        setCurrentPage(1);
    };

    const [popupVisible, setPopupVisible] = useState(false);

    const togglePopup = () => {
        setPopupVisible(!popupVisible);
    };

    //endregion

    const handleRowClick = (index) => {
        setExpandedRow(expandedRow === index ? null : index); // 클릭한 행의 index를 상태로 저장
    };

    //region Alert

    const [pendingUserOutFl, setPendingUserOutFl] = useState(null);
    const [alertShow, setAlertShow] = useState(false);
    const msgConfirmData1 = "선택된 회원이 탈퇴됩니다.";
    const msgConfirmData2 = "정말 탈퇴하시겠습니까?";
    // const outFlAlert = (()=> {setAlertShow(true)})
    const outFlAlert = (newValue) => {
        setPendingUserOutFl(newValue);
        setAlertShow(true);
    };

    const modalCancel = useCallback (() => {setAlertShow(false);})

    //endregion

    const [cData, setCData] = useState({ userOutFl: 'N' });
    const [outFlPopup, setOutFlPopup] = useState(false);
    // [구매대행 API] 웹 '회원상세정보'와 동일하게 수수료면제도 모바일에서 핸들링할 수 있도록 추가
    const [feeFlPopup, setFeeFlPopup] = useState(false);
    const [pendingUserFeeFl, setPendingUserFeeFl] = useState(null);
    const [feeAlertShow, setFeeAlertShow] = useState(false);
    const msgFeeConfirmData1 = "선택된 회원의 수수료면제 여부가 변경됩니다.";
    const msgFeeConfirmData2 = "변경하시겠습니까?";
    const feeFlAlert = (newValue) => {
        setPendingUserFeeFl(newValue);
        setFeeAlertShow(true);
    };
    const feeModalCancel = useCallback(() => { setFeeAlertShow(false); });

    /** endregion */

    /** region Event  */

    useEffect(() => {
        select();
    }, [])

    const select = () => {
        axios({
            method: 'get',
            url: '/member/adminuserselect',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                const filteredData = response.data.filter(item => item.role === "0");
                const sortedData = filteredData.sort((a, b) => b.mbNum - a.mbNum); // mbNum 기준 내림차순 정렬
                setUserData(sortedData);

                const updatedData = sortedData.map(user => ({
                    ...user,
                    profilePhoto: user.profileDTO ? "https://toeloperfile.s3.ap-northeast-2.amazonaws.com/profileImage/" + user.profileDTO.filename : profileImage
                }));

                setUserData(updatedData);
                console.log("업데이트된 유저 데이터:", updatedData);
            })
            .catch(() => {})
    };

    const outFlUpdate = (newValue) => {
        axios.post('/member/userOutFlupdate', {
            mbNum: userData[expandedRow].mbNum,
            userOutFl: newValue
        }, {
            headers: {
                'Authorization': LCAT,
                'Content-Type': 'application/json',
            }
        })
            .then(() => {
                setAlertShow(false);
                setPendingUserOutFl(null);
                setUserData(prevUserData => {
                    const updatedUserData = [...prevUserData];
                    updatedUserData[expandedRow] = {
                        ...updatedUserData[expandedRow],
                        userOutFl: newValue
                    };
                    return updatedUserData;
                });
            })
            .catch((error) => {
                console.error("에러:", error);
            });
    };

    /** 수수료면제 여부 변경 (웹 AdminUserInfoPg.js 의 delFeeUpdate 와 동일 로직) */
    const feeFlUpdate = (newValue) => {
        axios.post('/member/userFeeFlupdate', {
            mbNum: userData[expandedRow].mbNum,
            delFeeEmpFl: Number(newValue)
        }, {
            headers: {
                'Authorization': LCAT,
                'Content-Type': 'application/json',
            }
        })
            .then(() => {
                setFeeAlertShow(false);
                setPendingUserFeeFl(null);
                setUserData(prevUserData => {
                    const updatedUserData = [...prevUserData];
                    updatedUserData[expandedRow] = {
                        ...updatedUserData[expandedRow],
                        delFeeEmpFl: Number(newValue)
                    };
                    return updatedUserData;
                });
            })
            .catch((error) => {
                console.error("에러:", error);
            });
    };

    /** endregion */

    const printInflowPath = (type) => {
        let path = "일반유입"
        if (type === '1') {
            path = "구글광고"
        } else if (type === '2') {
            path = "유튜브광고"
        } else if (type === '3') {
            path = "페이스북광고"
        } else if (type === '4') {
            path = "인스타광고"
        } else if (type === '5') {
            path = "네이버광고"
        } else if (type === '6') {
            path = "틱톡광고"
        } else if (type === '7') {
            path = "쓰레드광고"
        } else if (type === '8') {
            path = "트위터광고"
        } else if (type === '9') {
            path = "지피티광고"
        } else if (type === '10') {
            path = "제미나이광고"
        } else if (type === '11') {
            path = "커뮤니티광고"
        }
        return path;
    }

    const printJoinType = (type) => {
        let path = "일반가입"
        if (type === '0') {
            path = "일반가입"
        } else if (type === '1') {
            path = "네이버"
        } else if (type === '2') {
            path = "구글"
        } else if (type === '3') {
            path = "애플"
        } else if (type === '4') {
            path = "카카오"
        } else if (type === '5') {
            path = "페이스북"
        } else if (type === '6') {
            path = "라인"
        }
        return path;
    }



    return (
        <div id="m-a-userinfo-pg-container">
            <div className="m-a-title-frame">
                <img className="wd-35 ht-35" alt="" src={maCateImg}/>
                <p className="p-t-6">회원정보</p>
            </div>
            <div className="m-a-card display-flex flex-column m-b-15">
                <div className="m-a-event-frame">
                    <div className="m-a-header-event">
                        <div className="m-a-header-event-combo">
                            <div className="m-a-combo font-t-cont font-c-default wd-55 ht-40 font-s-14 m-a-flex-jc-start m-r-10" onClick={togglePopup}>
                                <div className="font-t-cont">{perPg}</div>
                            </div>
                            {popupVisible && (
                                <MAdminPageSmallEvent perPg={perPg} handleSelectChange={handleSelectChange} togglePopup={togglePopup} />
                            )}
                        </div>
                    </div>
                    <div className="m-a-header-event">
                        <div className="m-a-header-event-search">
                            <MAdminSearchEvent searchInput={searchInput} handleSearchInputChange={handleSearchInputChange} />
                        </div>
                    </div>
                </div>
                <div className="m-a-tb-frame">
                    <div className="m-a-div-tb">
                        <div className="m-a-div-tb-head ht-60">
                            <div className="wd-35"><p>번호</p></div>
                            <div className="wd-110"><p>고객명</p></div>
                            <div className="wd-200"><p>아이디</p></div>
                            <div className="wd-70"><p>CS언어</p></div>
                            <div className="wd-70"><p>MB번호</p></div>
                            <div className="wd-90"><p>유입경로</p></div>
                            <div className="wd-90"><p>가입유형</p></div>
                            <div className="wd-90"><p>가입일자</p></div>
                        </div>
                        {searchData.slice(0, displayLimit).map((cData, i) => (
                            <div key={i}>
                                <div className="m-a-div-tb-body ht-70" onClick={() => handleRowClick(i)}>
                                    <div className="wd-35"><p>{indexOfFirst + i + 1}</p></div>
                                    <div className="wd-110"><p className="font-b">{cData.userName}</p></div>
                                    <div className="wd-200"><p className="font-b">{cData.id}</p></div>
                                    <div className="wd-70"><p>{cData.lang}</p></div>
                                    <div className="wd-70"><p>BT{cData.mbNum}</p></div>
                                    <div className="wd-90"><p>{printInflowPath((cData.channelType))}</p></div>
                                    <div className="wd-90"><p>{printJoinType((cData.joinType))}</p></div>
                                    <div className="wd-90">
                                        <p>{`${cData.regDate.substring(2, 4)}-${cData.regDate.substring(4, 6)}-${cData.regDate.substring(6, 8)}`}</p>
                                    </div>
                                </div>
                                {expandedRow === i && (
                                    /* ══════════════════════════════════════════════════════════════
                                       [구매대행 API] 회원상세정보 드랍다운
                                        - 기존에는 내용이 잘리고 정렬이 맞지 않아 웹 '회원상세정보'와 동일한
                                          항목 구성으로 다시 채우고, 모바일 폭에 맞춰 2열 그리드로 재정렬했다.
                                       ══════════════════════════════════════════════════════════════ */
                                    <div className="m-a-user-dt-frame font-t-cont font-c-default font-s-13"
                                         style={{padding: "14px 16px", boxSizing: "border-box", width: "100%"}}>

                                        {/* 프로필 / 예치금 / 적립금 / 메일수신 */}
                                        <div style={{display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px"}}>
                                            <img alt="profile" src={cData.profilePhoto || profileImage}
                                                 onError={(e) => { e.currentTarget.src = profileImage; }}
                                                 style={{width: "44px", height: "44px", borderRadius: "50%", objectFit: "cover", flex: "0 0 auto"}}/>
                                            <div style={{minWidth: 0, flex: 1}}>
                                                <p className="font-b" style={{margin: "0 0 4px", fontSize: "14px", wordBreak: "break-all"}}>
                                                    {cData.userName} <span className="font-s-12">(BT {cData.mbNum})</span>
                                                </p>
                                                <div style={{display: "flex", flexWrap: "wrap", gap: "10px", fontSize: "12px"}}>
                                                    <span><img className="wd-13 ht-13 m-b-2 m-r-3" alt="deposit" src={deposit}/>{(cData.deposit || 0).toLocaleString()}</span>
                                                    <span><img className="wd-13 ht-13 m-b-2 m-r-3" alt="point" src={pointPay}/>{(cData.point || 0).toLocaleString()}</span>
                                                    <span><img className="wd-13 ht-13 m-b-2 m-r-3" alt="coupon" src={coupons}/>{(cData.coupons ? cData.coupons.length : 0)}</span>
                                                    <span><img className="wd-13 ht-13 m-b-2 m-r-3" alt="mail" src={mail}/>{cData.mailRecFl ? 'Y:수신' : 'N:거부'}</span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* 상세항목 (웹 '회원상세정보'와 동일 구성) */}
                                        <div style={{display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", columnGap: "12px", rowGap: "8px"}}>
                                            <MAdminUserInfoItem label="아이디" value={cData.id} full/>
                                            <MAdminUserInfoItem label="CS 국가" value={cData.lang}/>
                                            <MAdminUserInfoItem label="가입유형" value={printJoinType(cData.joinType)}/>
                                            <MAdminUserInfoItem label="유입경로" value={printInflowPath(cData.channelType)}/>
                                            {/* [구매대행 API] 가입경로 : apiJoinFl 이 true 면 쇼핑몰 API 버튼을 통해 유입/가입한 회원 */}
                                            <MAdminUserInfoItem label="가입경로" value={cData.apiJoinFl ? '쇼핑몰' : '비토리지'}/>
                                            <MAdminUserInfoItem label="가입일시" value={cData.regTime} full/>
                                            <MAdminUserInfoItem label="정보수정일시" value={cData.modiTime} full/>
                                            <MAdminUserInfoItem label="탈퇴일시" value={cData.secTime} full/>
                                        </div>

                                        {/* 수수료면제 / 탈퇴여부 */}
                                        <div style={{display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "12px"}}>
                                            <div style={{display: "flex", alignItems: "center", gap: "6px"}}>
                                                <span className="font-b font-s-12">수수료면제</span>
                                                <div className="m-a-combo wd-90 ht-26 font-s-12 m-a-flex-jc-start"
                                                     onClick={() => setFeeFlPopup(true)}>
                                                    {cData.delFeeEmpFl ? 'Y:면제대상' : 'N:대상아님'}
                                                </div>
                                            </div>
                                            <div style={{display: "flex", alignItems: "center", gap: "6px"}}>
                                                <img className="wd-14 ht-14" alt="out" src={outFl}/>
                                                <div className="m-a-combo wd-80 ht-26 font-s-12 font-b m-a-flex-jc-start"
                                                     onClick={() => setOutFlPopup(true)}>
                                                    {cData.userOutFl ? 'Y:탈퇴' : 'N:회원'}
                                                </div>
                                            </div>
                                        </div>

                                        {/* 탈퇴/회원 선택 팝업 */}
                                        {outFlPopup && (
                                            <div className="m-a-page-popup-container" onClick={(e) => { e.stopPropagation(); setOutFlPopup(false); }}>
                                                <div className="m-a-page-popup-frame" onClick={(e) => e.stopPropagation()}>
                                                    <div className="m-a-page-popup-header-frame">
                                                        <div className="font-t-title font-s-18 m-t-4">탈퇴/회원 선택</div>
                                                    </div>
                                                    <div className="m-a-page-popup-body-frame">
                                                        <div onClick={() => { setOutFlPopup(false); outFlAlert(true); }}
                                                             className={`m-a-card m-t-10 m-b-10 ${cData.userOutFl ? 'm-a-selected-option' : ''}`}>
                                                            Y:탈퇴
                                                        </div>
                                                        <div onClick={() => { setOutFlPopup(false); outFlAlert(false); }}
                                                             className={`m-a-card m-t-10 m-b-10 ${!cData.userOutFl ? 'm-a-selected-option' : ''}`}>
                                                            N:회원
                                                        </div>
                                                    </div>
                                                    <div className="m-a-page-popup-footer-frame">
                                                        <div className="m-a-file-bt-container">
                                                            <button className="m-a-colorBt ht-40 m-b-5 wd-80" onClick={(e) => { e.stopPropagation(); setOutFlPopup(false); }}>
                                                                <div className="m-a-colorBt-text font-t-cont">Close</div>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* 수수료면제 선택 팝업 */}
                                        {feeFlPopup && (
                                            <div className="m-a-page-popup-container" onClick={(e) => { e.stopPropagation(); setFeeFlPopup(false); }}>
                                                <div className="m-a-page-popup-frame" onClick={(e) => e.stopPropagation()}>
                                                    <div className="m-a-page-popup-header-frame">
                                                        <div className="font-t-title font-s-18 m-t-4">수수료면제 선택</div>
                                                    </div>
                                                    <div className="m-a-page-popup-body-frame">
                                                        <div onClick={() => { setFeeFlPopup(false); feeFlAlert(true); }}
                                                             className={`m-a-card m-t-10 m-b-10 ${cData.delFeeEmpFl ? 'm-a-selected-option' : ''}`}>
                                                            Y:면제대상
                                                        </div>
                                                        <div onClick={() => { setFeeFlPopup(false); feeFlAlert(false); }}
                                                             className={`m-a-card m-t-10 m-b-10 ${!cData.delFeeEmpFl ? 'm-a-selected-option' : ''}`}>
                                                            N:대상아님
                                                        </div>
                                                    </div>
                                                    <div className="m-a-page-popup-footer-frame">
                                                        <div className="m-a-file-bt-container">
                                                            <button className="m-a-colorBt ht-40 m-b-5 wd-80" onClick={(e) => { e.stopPropagation(); setFeeFlPopup(false); }}>
                                                                <div className="m-a-colorBt-text font-t-cont">Close</div>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                    {displayLimit >= 30 && searchData.length > displayLimit && (
                        <div className="text-center m-t-20">
                            <button className="admin-btn-long admin-btn-basic p-l-10" onClick={loadMoreData}>더보기
                                <MdKeyboardArrowDown className="m-l3 font-s-17"/>
                            </button>
                        </div>
                    )}
                </div>
            </div>
            {alertShow === true ?
                <MsgSelectModal alertShow={alertShow} eventHandle1={modalCancel} eventHandle2={() => outFlUpdate(pendingUserOutFl)} msgData1={msgConfirmData1} msgData2={msgConfirmData2}/>
                : null}
            {feeAlertShow === true ?
                <MsgSelectModal alertShow={feeAlertShow} eventHandle1={feeModalCancel} eventHandle2={() => feeFlUpdate(pendingUserFeeFl)} msgData1={msgFeeConfirmData1} msgData2={msgFeeConfirmData2}/>
                : null}
            <TopBtn/>
        </div>
    );
}

/** 회원상세정보 항목 1개 (라벨 + 값) — 모바일 폭에서 잘리지 않도록 줄바꿈 허용 */
function MAdminUserInfoItem({label, value, full}) {
    return (
        <div style={{
            gridColumn: full ? "1 / -1" : "auto",
            display: "flex", alignItems: "flex-start", gap: "6px", minWidth: 0,
        }}>
            <span className="font-b font-s-12" style={{flex: "0 0 auto", opacity: 0.75}}>{label}</span>
            <span className="font-s-12" style={{
                minWidth: 0, wordBreak: "break-all", whiteSpace: "normal", overflowWrap: "break-word",
            }}>{value || '-'}</span>
        </div>
    );
}

export default MAdminUserInfoPg;
